import { Component, OnInit, Input, Output } from '@angular/core';
import { AngularFireStorage, AngularFireUploadTask } from 'angularfire2/storage';

import { AngularFirestore } from "angularfire2/firestore";
										
import { Observable } from 'rxjs/Observable';
import { tap, finalize } from 'rxjs/operators';
import {  Subject } from 'rxjs/Rx';

@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})

export class FileUploadComponent {

  @Input() path: string = 'temp';
  @Input() css: string = '';
 
  // Main task 
  task: AngularFireUploadTask;

  // Progress monitoring
  percentage: Observable<number>;

  snapshot: Observable<any>;

  // Download URL
  downloadURL: Observable<string>;
  renderImg:boolean=true;

   onCompleteUploadFileListenner:any;

  // State for dropzone CSS toggling
  isHovering: boolean;

  files:any[];

  inputPaste:string='';

  constructor(private storage: AngularFireStorage, private db: AngularFirestore) {
    this.init();
   }

   init(){
    this.files=new Array();
    this.percentage=null;
    this.snapshot=null;
   }

  
  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  setOnCompleteUploadFileListenner(onCompleteUploadFileListenner:any){
	  this.onCompleteUploadFileListenner=onCompleteUploadFileListenner;
	  
  }
  setRenderImg(renderImg:boolean){
    
	  this.renderImg=renderImg;	  
  }  
  
  setRenderCurrentURL(currentURL:string){	  
	  if(currentURL)
		  this.downloadURL=Observable.create(a=>a.next(currentURL));
	  
  }

  paste(event){
      var clipData = event.clipboardData;
      for(let item of clipData.items) {
          console.log(item);
          
         
      };
  
  
  }

  pasteFile(e) {
    console.log(e);
    
    for (var i = 0 ; i < e.clipboardData.items.length ; i++) {
        var file = e.clipboardData.items[i];        
        
        if (file.type.indexOf("image") != -1) {            
            this.uploadFile(file.getAsFile());            
        } else {
            alert("Lo que esta intentando pegar no es una imagen.");
            this.inputPaste='';
        }
    }
}

  startUpload(event: FileList) {
    // The File object
    let file = event.item(0)
    this.uploadFile(file);
    // Client-side validation example
    /*if (file.type.split('/')[0] !== 'image') { 
      console.error('unsupported file type :( ')
      return;
    }*/

        
  }

  uploadFile(file:any){
    // The storage path
    const name = file.name?file.name:'nuevo_archivo';
    const path = `${this.path}/${new Date().getTime()}_${name}`;
    const type = file.type.split('/')[0];
    let totalBytes = 0;

    // Totally optional metadata
    const customMetadata = { app: 'Mensajeros Ecuador!' };
    
    // The main task
    this.task = this.storage.upload(path, file, { customMetadata })

    // Progress monitoring
    this.percentage = this.task.percentageChanges();
    this.snapshot   = this.task.snapshotChanges();

    const fileRef = this.storage.ref(path); // Add this line to get the path as a ref
    this.snapshot.pipe(
          tap(snap => {
            if (snap.bytesTransferred === snap.totalBytes) {
              totalBytes =  snap.totalBytes;
            }
          }),
    	    finalize(() =>{
                this.downloadURL = this.storage.ref(path).getDownloadURL();                
                this.downloadURL.subscribe(url=>{
                  const file={
                    ref: path,
                    type: type,
                    url: url,
                    name: name,
                    size: this.fileSize(totalBytes)
                  }
                  this.files.push(file);
                });    	    			
    	    } )
    	 )
    	.subscribe();
  }

  // Determines if the upload task is active
  isActive(snapshot) {
    return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
  }

  deleteFile(index){
    this.files.splice(index, 1);
  }

  fileSize(sizeInBytes:number){
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let power = Math.round(Math.log(sizeInBytes) / Math.log(1024));
    power = Math.min(power, units.length - 1);

    const size = sizeInBytes / Math.pow(1024, power); // size in new units
    const formattedSize = Math.round(size * 100) / 100; // keep up to 2 decimals
    const unit = units[power];

    return size ? `${formattedSize} ${unit}` : '0';
  }

}